<template>
  <div :class="bindDiscountCls" :style="{ background }" @click="click">
    <template v-if="isNoLogin">
      <div class="tip flex-start">
        <img
          :src="require(`@/assets/images/detail/discount-icon.png`)"
          alt="discount icon"
        />
        <div class="desc">{{ tip }}</div>
      </div>
    </template>
    <template v-else>
      <!-- 折扣提示 -->
      <div class="tip flex-start">
        <img
          :src="require(`@/assets/images/detail/discount-icon.png`)"
          alt="discount icon"
        />
        <div class="desc" :class="isNoLogin ? 'genshin' : ''">{{ tip }}</div>
      </div>
      <!-- 折扣金额 -->
      <div class="flex-center discount-right">
        <div class="flex-col-center">
          <!-- 金额&loading -->
          <div class="discount-amount">
            <van-loading v-show="loading" type="spinner" class="loading-icon" />
            <GeneralPrice
              v-show="showAmount && !loading"
              :injectColor="'#F96000'"
              :className="'c-money'"
              :prefix="'-'"
              :price="Number(amount)"
            />
          </div>

          <!-- 用户选择的优惠券 有即将失效的 -->
          <div class="countdown-item" v-if="countdownData.show">
            {{ $t('coupon.expiring') }}
            <Countdown
              class="countdown"
              :userCouponExpireTime="countdownData.time"
            />
          </div>
        </div>
        <MBIcon
          v-if="!isRuPubgm"
          name="icon-arrow"
          class="arrow"
          :size="32"
          color="#F96000"
        />
      </div>
    </template>
  </div>
</template>
<script>
  // 优惠信息栏
  import Countdown from '../Countdown'
  import GeneralPrice from '@/components/GeneralPrice'
  import MBIcon from '@/components/MBIcon'
  import orderBy from 'lodash/orderBy'
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState, mapGetters } from 'vuex'
  import { isNewGenshin } from '../utils'

  export default {
    mixins: [styleConfiguration],
    props: {
      // 优惠金额=配置原价-配置售价
      discountAmount: {
        type: Number,
        default: 0,
      },
      // 当前游戏的优惠券列表
      coupons: {
        type: Object,
        default: () => {},
      },
      // 金额的loading状态
      loading: {
        type: Boolean,
        default: false,
      },
      couponsLoading: {
        type: Boolean,
        default: false,
      },
      // 选中优惠券的金额
      choiceCouponMoney: {
        type: Number,
        default: 0,
      },
      // 倒计时数据
      countdownData: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      Countdown,
      // MoneyDisplay,
      MBIcon,
      GeneralPrice,
    },
    data() {
      return {}
    },
    computed: {
      ...mapState(['gameName', 'userInfo', 'isDesktop']),
      ...mapGetters('detail', ['gameCouponList']),
      ...mapGetters(['isRuPubgm', 'isLogin']),
      bindDiscountCls() {
        const defs = ['discount-wrapper', 'space-between']
        if (this.isNoLogin) {
          defs.push('genshin')
        }

        if (this.isDesktop) {
          defs.push('discount-wrapper-desktop')
        } else {
          defs.push('discount-wrapper-mobile')
        }
        return defs
      },
      isNoLogin() {
        return isNewGenshin(this.gameName) && !this.isLogin
      },
      background() {
        const { gameName } = this
        if (gameName === 'pubgm') return '#333D45'
        if (isNewGenshin(gameName)) return '#FFFFFF'

        const ncolor = this.discountColor.backgroundColor
        return ncolor || '#3F3F53'
      },
      tip() {
        // 提示信息
        if (this.isNoLogin) return this.$t('genshinNew.new_user_tips')
        // 用户本游戏没有可使用的优惠券 - 展示已优惠
        if (this.gameCouponList.length === 0) return this.$t('coupon.discount')
        // 用户选择的套餐没有可用的优惠券时
        const couponList = this.coupons?.couponList || []
        if (couponList.length === 0) {
          return this.tipByNoCoupon(this.gameCouponList)
        }
        // 已优惠
        return this.$t('coupon.discount')
      },
      showAmount() {
        // 是否展示金额
        // 如果获取优惠券接口还在加载中，则不展示
        if (this.couponsLoading) return false
        // 用户本游戏没有可使用的优惠券 - 展示
        if (this.gameCouponList.length === 0) return true
        // 用户选择的套餐没有可用的优惠券时
        const couponList = this.coupons?.couponList || []
        // 游戏有可用优惠券 且 套餐有可用优惠券
        return couponList.length > 0
      },
      amount() {
        // 金额
        // 优惠金额=配置原价-配置售价
        const { discountAmount } = this
        const couponList = this.coupons?.couponList || []
        // 用户选择的套餐没有可用的优惠券时  或者 用户本游戏没有可使用的优惠券时
        if (this.gameCouponList.length === 0 || couponList.length === 0) {
          return discountAmount
        }
        // 用户选择的套餐有可用的优惠券时
        return this.choiceCouponMoney + discountAmount
      },
    },
    methods: {
      click() {
        this.$emit('click')
      },
      getLowerCoupon(data) {
        // 最低使用限制金额的券 - 根据使用门槛进行升序排序，获取第一个
        const lowerCoupon = orderBy(data, ['conditionPrice'], ['asc'])
        return lowerCoupon.length > 0 ? lowerCoupon[0] : {}
      },
      tipByNoCoupon(data) {
        // 用户选择的套餐没有可用的优惠券 - 提示
        // 优惠券使用限制金额=用户本游戏可使用的所有优惠券，最低使用限制金额的券的限制金额
        const lowerCoupon = this.getLowerCoupon(data)
        const {
          couponType,
          currency,
          couponPrice,
          couponDiscount,
          conditionPrice,
        } = lowerCoupon
        if (couponType === 1) {
          // 立减券
          return this.$t('coupon.discount_condition2', {
            currencySymbol: currency,
            amount: this.$options.filters['formatMoney'](conditionPrice),
            discountAmount: this.$options.filters['formatMoney'](couponPrice),
          })
        }
        // 折扣券
        const discountRatio = `${100 - couponDiscount}%`
        return this.$t('coupon.discount_condition1', {
          currencySymbol: currency,
          amount: this.$options.filters['formatMoney'](conditionPrice),
          discountRatio,
        })
      },
    },
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
